import React from 'react';
import { useMemo } from 'react';
import Icon from '../Icon';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import clsx from 'clsx';

const MiniCartIcon = () => {
  const { orderRows, addToCartAnimating = false } = useTypedSelector(
    (state) => state.cart
  );

  const quantity = useMemo(
    () =>
      Math.min(
        orderRows.reduce((prev, current) => prev + current.quantity, 0),
        99
      ),
    [orderRows]
  );

  return (
    <div className="relative">
      <Icon
        className="icon h-6 w-6 text-gray-700 transition ease-in-out group-[.is-light-theme]:text-white store-screen:h-8 store-screen:w-8"
        name="shopping-cart"
      />
      {quantity > 0 ? (
        <div
          className={clsx(
            'absolute -right-2 -top-1.5 flex h-5 w-5 items-center justify-center rounded-[100%] text-center text-sm leading-[1.3] text-white transition duration-[125ms] ease-in-out ',
            addToCartAnimating && 'scale-150',
            addToCartAnimating ? 'bg-gray-700' : 'bg-gray-900'
          )}
        >
          {quantity}
        </div>
      ) : null}
    </div>
  );
};

export default MiniCartIcon;
